import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: '/not-found'
  },
  {
    name: 'clue-form',
    component: () => import('./views/car/ClueFormPage.vue'),
    meta: {
      title: '新车询价'
    }
  },
  {
    name: 'success',
    component: () => import('./views/car/Success.vue'),
    meta: {
      title: '成功'
    }
  },
  {
    name: 'not-found',
    component: () => import('./views/NotFound.vue'),
    meta: {
      title: '页面不存在'
    }
  },
  {
    name: 'privacy-book',
    component: () => import('./views/car/PrivacyBook.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    name: 'pc-ad',
    component: () => import('./views/other/PcAd.vue'),
    meta: {
      title: 'PC广告'
    }
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

const router = new Router({ routes })

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  next()
})

export {
  router
}
